import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getManagerTransactions = async (startDate, endDate) => {
  try {
    const token = getToken();

    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);

    const query = params.toString();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/transactions/${query ? `?${query}` : ""}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet manager transactions fetch error:", error);
    throw error;
  }
};

const getTransactionById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/transactions/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Transaction detail fetch error:", error);
    throw error;
  }
};

export { getManagerTransactions, getTransactionById };
